export const cssPreviewMode = 'css-preview-mode'
